import { getJSON } from './http';
import type { Locale } from '../i18n';

// Localized name bag used across the bundle, cantons and tournaments.
export type I18nName = { en: string; de: string; fr: string; it: string };

export function localizedName(n: I18nName | undefined, locale: Locale): string {
  if (!n) return '';
  return n[locale] || n.en || '';
}

export type Nation = { code: string; name: I18nName; confederation: string; flag: string };
export type Canton = { code: string; name: I18nName; capital: string; flag: string };

// The static bundles double as offline fallbacks for the live API; for the
// onboarding pickers we only need their reference data, so read them directly.
let nationsCache: Nation[] | null = null;
let cantonsCache: Canton[] | null = null;

export async function loadNations(): Promise<Nation[]> {
  if (nationsCache) return nationsCache;
  const bundle = await getJSON<{ teams: Record<string, Nation> }>('/data/wc2026.json');
  nationsCache = Object.values(bundle.teams).sort((a, b) => a.name.en.localeCompare(b.name.en));
  return nationsCache;
}

export async function loadCantons(): Promise<Canton[]> {
  if (cantonsCache) return cantonsCache;
  const data = await getJSON<{ cantons: Record<string, Canton> }>('/data/cantons.json');
  cantonsCache = Object.values(data.cantons).sort((a, b) => a.code.localeCompare(b.code));
  return cantonsCache;
}
